<template>
  <div class="nav">
    <ul>
      <router-link tag="li" to="/account" :class="{'active': $route.path.split('/')[1] == 'account' || $route.path.split('/')[1] == 'master'
       || $route.path.split('/')[1] == 'createmaster' || $route.path.split('/')[1] == 'editmaster'
       || $route.path.split('/')[1] == 'detail' || $route.path.split('/')[1] == 'create'
      || $route.path.split('/')[1] == 'alter'}">
        <i class="ico ico-dashboard" @click="pageRefresh('/account')"></i>
        <div class="txt" @click="pageRefresh('/account')">Venue Account<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/keywordList" tag="li" :class="{'active': $route.path == '/keywordList' || $route.path == '/keyword'}">
        <i class="ico ico-pl" @click="pageRefresh('/keywordList')"></i>
        <div class="txt" @click="pageRefresh('/keywordList')">Create P&amp;L Category<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/smsList" tag="li" :class="{'active': $route.path == '/smsList' || $route.path == '/sms'}">
        <i class="ico ico-sms" @click="pageRefresh('/smsList')"></i>
        <div class="txt" @click="pageRefresh('/smsList')">SMS<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/feelist" tag="li" :class="{'active': $route.path == '/feelist' || $route.path.split('/')[1] == 'feedetail'}">
        <i class="ico ico-fees" @click="pageRefresh('/feelist')"></i>
        <div class="txt" @click="pageRefresh('/feelist')">Venue Fees<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/doshii" tag="li" :class="{'active': $route.path == '/doshii' || $route.path.split('/')[1] == 'doshiidetail'
      || $route.path.split('/')[1] == 'connect' || $route.path.split('/')[1] == 'createvenue' ||
      $route.path.split('/')[1] == 'doshiilink'}">
        <i class="ico ico-doshii" @click="pageRefresh('/doshii')"></i>
        <div class="txt" @click="pageRefresh('/doshii')">Doshii<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/poslist" tag="li" :class="{'active': $route.path == '/poslist' || $route.path.split('/')[1] == 'posadd'
        || $route.path.split('/')[1] == 'posedit'}">
        <i class="ico ico-pos" @click="pageRefresh('/poslist')"></i>
        <div class="txt" @click="pageRefresh('/poslist')">POS Brand<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <router-link to="/setting" tag="li" :class="{'active': $route.path == '/setting' || $route.path == '/version'}">
        <i class="ico ico-setting" @click="pageRefresh('/setting')"></i>
        <div class="txt" @click="pageRefresh('/setting')">Setting<i class="el-icon-arrow-right"></i></div>
      </router-link>
      <li @click="out">
        <i class="ico ico-logout"></i>
        <div class="txt">Logout<i class="el-icon-arrow-right"></i></div>
      </li>
    </ul>
  </div>
</template>

<script>
import api from '../../api/login'
import { env } from '../../env'

export default {
  inject: ['reload'],
  name: 'navcon',
  data () {
    return {
      env: env
    }
  },
  methods: {
    pageRefresh (path) {
      if (path == this.$route.path) {
        this.$router.go(0)
      }
    },
    out(){
      api.logout({callback:this.callback})
    },
      callback (res) {
        if (res.data.code === 0) {
          window.sessionStorage.removeItem('token')
          this.$router.replace('/login')
        } else {
          this.$box.alert('',message,'error')
        }
      }
    
  }
}
</script>

<style lang="scss" scoped>
.nav{
  color: #fff;
  width: 160px;
  position: fixed;
  left: 0;
  top: 120px;
  z-index: 6;
  background: #212429;
  height: 100vh;
  ul{
    width: 130px;
    box-sizing: border-box;
    padding-left: 30px;
    padding-top: 62px;
    li{
      width: 100%;
      height: 70px;
      position: relative;
      cursor: pointer;
      .ico{
        display: block;
        width: 100%;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 30px 30px;
        background-position:center center;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 6;
      }
      .txt{
        width: 100px;
        height: 70px;
        box-sizing: border-box;
        padding-left: 95px;
        position: absolute;
        left: 0;
        top: 0;
        background: #2B3444;
        font-size: 16px;
        line-height: 70px;
        opacity: 0;
        transition: all .5s;
        white-space: nowrap;
        overflow: hidden;
        z-index: 5;
        i{
          position: absolute;
          right: 14px;
          top: 26px;
        }
      }
    }
    li:hover{
      .txt{
        width: 290px;
        opacity: 1;
      }
    }
    li .ico-dashboard{
      background-image: url('../../assets/1.png');
    }
    li .ico-pl{
      background-image: url('../../assets/2.png');
    }
    li .ico-sms{
      background-image: url('../../assets/3.png');
    }
    li .ico-fees{
      background-image: url('../../assets/4.png');
    }
    li .ico-doshii{
      background-image: url('../../assets/doshi.png');
    }
    li .ico-pos{
      background-image: url('../../assets/pos.png');
    }
    li .ico-eos{
      background-image: url('../../assets/eos.svg');
    }
    li .ico-setting{
      background-image: url('../../assets/m6.png');
    }
    .logout{
      background-image: url('../../assets/d.png');
    }
    /*li:nth-child(6) .ico{
      background-image: url('../../assets/p.png');
    }*/
    li .ico-logout{
      background-image: url('../../assets/5.png');
    }
    .active{
      background: #2B3444;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/nav/navcon.vue